<template>
  <div>
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/scenarion">Visa alla scenarion</router-link>
        <router-link tag="li" to="/scenarion/ny">Skapa nytt scenario</router-link>
      </ul>
      <div class="clear"></div>
    </div>

    <div class="bootstrap-wrapper" v-if="$root.data.scenarios.length">
      <div class="container" style="padding:0px;margin:0px;">
        <div class="row">
          <div class="col-md-3" v-for="scenario in $root.data.scenarios">            
            <div class="content" :style="colStyle(scenario)">
              <div v-if="scenario.status !== 'running'">
                <div @click="edit(scenario)" class="gear">
                  <img class="gearIcon" src="https://d30y9cdsu7xlg0.cloudfront.net/png/31188-200.png" width="20">
                </div>
                
                <div style="opacity:.3"><img :src="scenario.iconURL" width="25"></div>
                <div @click="run(scenario)" class="title">{{ scenario.name }}</div>
                <div class="descr">{{ scenario.commands.length }} kommandon</div>                
              </div>
              <div v-else>
                <pixel-spinner :animation-duration="1200" :size="60" :color="scenario.color" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>      
      <info-view>
        <img src="../assets/nexa/scenario_svart.png" style="margin-bottom:1em;">
        <h3>Inga scenarion här inte</h3>
        <div>Ett scenario låter dig utföra flera kommandon genom ett klick men det verkar inte som om du har lagt till några scenario, du kan göra det med hjälp av menyn här ovanför.</div>
        <button @click="add" style="margin-top:2em;">Skapa ett nu</button>
      </info-view>
    </div>

  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { PixelSpinner } from 'epic-spinners'
  import { VueTabs, VTab } from 'vue-nav-tabs'
  import 'vue-nav-tabs/themes/paper.css'
  import { eventbus } from '../eventbus.js'
  import infoView from './views/infoView'

  export default {
    name: 'scenarion',
    components: {
      PixelSpinner,
      VTab,
      VueTabs,
      infoView
    },
    data () {
      return {}
    },
    created () {
      // Lyssa
      eventbus.$on('scenario', (json) => {
        const scenario = this.$root.data.scenarios.find(scenario => scenario.id === json.scenario)
        if (scenario) {
          if (json.action === 'Started') {
            scenario.status = 'running'
          } else {
            setTimeout(() => {
              scenario.status = 'idle'
            }, 2500)
          }
        }
      })
    },
    methods: {
      add () {
        this.$router.push({
          name: 'scenario_ny'
        })
      },
      
      colStyle (scenario) {
        return {
          'border-bottom' : '4px solid ' + scenario.color,
        }
      },
      
      run (scenario) {
          scenario.status = 'running'

        HTTP.post('scenarios/cmd', {
          scenid: scenario.id,
          cmd: 'start'
        })
        .then(res => res.data)
        .then(json => {
          scenario.status = 'running'
        })
      },
      
      edit (scenario) {
        this.$router.push({
          name: 'scenarion_edit',
          params: {
            id: scenario.id
          }
        })
      }
    },
    computed: {},
    destroyed () {
      eventbus.$off('scenario')
    }
  }
</script>

<style scoped>
  .col-md-3 .content {
    border:1px solid #e8e8e8;
    padding:12px;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius:4px;
    height:120px;
    cursor:pointer;
    text-align: center;
    margin-bottom:15px;
  }
  
  .col-md-3 .title {
    font-weight: bold;
  }
  
  .col-md-3 .descr {
    font-size:11px;
    text-align: center;
    color:#d2d2d2;
  }
  
  .image img {
    width:21px;
    height:21px;
    object-fit:contain;
  }
  
  @keyframes spin {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }
  
  .gear {
    position:absolute;
    right:12px;
    top:8px;
    z-index:1;
    opacity:0.5;
    width:40px;
    height:40px;
  }
  
  .gearIcon {
    animation-name: spin;
    animation-duration: 5000ms;
    animation-iteration-count: 3;
    animation-timing-function: linear; 
  }
</style>


// WEBPACK FOOTER //
// src/components/scenarion.vue